import { AppConfigService } from '@/config';
import { SentryService } from '@ianesthesie-kit/sentry';
import isEmpty from 'lodash/fp/isEmpty';
import kebabCase from 'lodash/fp/kebabCase';
import { stringify } from 'query-string';

export * from './date';
export * from './wrapError';

export function throwOnDev(err: any) {
  if (AppConfigService.getInstance().env === 'dev') {
    throw err;
  }
}

export const captureThrowOnDev = (e: any) => {
  const err = typeof e === 'string' ? new Error(e) : e;
  SentryService.getInstance().captureException(err);
  throwOnDev(err);
};

export const toKebabQuery = (
  paramObj: object | undefined,
  questionMark = true
) => {
  if (isEmpty(paramObj)) {
    return questionMark ? '?' : '';
  }
  const params = Object.entries(paramObj).reduce(
    (acc, [key, val]) => ({
      ...acc,
      [kebabCase(key)]: val
    }),
    {}
  );
  return `${questionMark ? '?' : ''}${stringify(params)}`;
};
